// extracted by mini-css-extract-plugin
module.exports = {"icon":"ArrowSelect_icon__hmGmQ","closedIcon":"ArrowSelect_closedIcon__211sj"};